








import ripple from "./ripple.vue";
import { Component, Watch, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        ripple
    }
})
export default class Alert extends Vue {
    @Prop({}) text:string;
    @Prop({}) delay:number
    @Prop({}) show:boolean

    isShow:boolean = false;

    mounted(){ 
        setTimeout(() => {
            if(this.show){
                this.toShow();
            }
        },this.delay);
    }

    toShow(){
        this.isShow = this.show;
    }

    @Watch('show')
    updateShow(to,from){
        this.toShow()
    }
}

